import React from "react";

export const TokenomicsSection = () => {
  return (
    <div className="relative w-full max-w-[1839px] mx-auto px-4 py-10 " id="tokenomics">
      <div className="relative w-full">
        {/* Description */}
     <div className="frame-38 flex max-md:flex-col items-center text-center gap-6">
  <header>
    <h1 className="font-fredoka text-6xl font-bold tracking-wider text-white leading-[72px] w-[629px] 
      max-md:w-full max-md:text-5xl max-md:leading-[56px] 
      max-sm:text-3xl max-sm:leading-10 max-sm:tracking-wide">
   
      <span className="bg-gradient-to-r from-pink-300 via-purple-300 to-blue-300 bg-clip-text text-transparent">
    Tokenomics Overview
      </span>
    </h1>
  </header>

  <div className="frame-39">
    <p className="text-wrapper-20 text-lg text-white text-center max-md:text-base">
      Discover a token built for joy and safety! Baby Unicorn combines
      a family-friendly design, a fun-filled ecosystem of games and
      rewards, a strong community spirit, and transparent, secure
      technology
    </p>
  </div>
</div>

        {/* Main Section */}
        <div className="flex flex-col lg:flex-row justify-between gap-10 mt-16 w-full items-start">
          {/* Chart + Legend */}
          <div className="w-full max-w-[546px] flex flex-col items-center lg:items-start justify-center pt-6 pb-2 px-2 rounded-2xl mx-auto">
            <div className="flex flex-wrap gap-2 justify-center lg:justify-start">
              {[
                { label: "Team & Advisors", color: "#b28dff" },
                { label: "Presale Allocation", color: "#ffc1e3" },
                { label: "Community & Events", color: "#aee2ff" },
                { label: "Staking Rewards", color: "#b8f2e6" },
                { label: "Liquidity & Reserve", color: "#ffd700" },
              ].map((item, i) => (
                <div key={i} className="inline-flex items-center gap-1 p-1">
                  <div className="w-4 h-4">
                    <div
                      className="w-3 h-3 rounded-md border border-[#191e26]"
                      style={{ backgroundColor: item.color }}
                    />
                  </div>
                  <div className="text-[#ffffffcc] text-base whitespace-nowrap">
                    {item.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="relative w-full sm:w-[260px] md:w-[350px] lg:w-[500px] xl:w-[531px] h-auto aspect-[531/346] mt-4">
              <img
                className="w-full h-full object-contain"
                src="MainChart.png"
                alt="Tokenomics Chart"
              />
            </div>
          </div>

          {/* Mobile Token Name */}
          <div className="flex flex-col items-center justify-center gap-2 mt-8 xl:hidden px-4 token-right-box">
            <div className="text-neutral-100 text-base font-semibold">Token Name</div>
            <div className="flex items-center justify-between w-full max-w-xs relative">
              <img
                className="w-[30px] h-[50px] object-contain"
                src="https://c.animaapp.com/mcbsvxniGDsCKx/img/vector-5.svg"
                alt="vector-start"
              />
              <div className="px-2 text-[20px] font-bold text-center leading-snug text-transparent bg-gradient-to-r from-[#ffa8d1] via-[#c3b1ff] to-[#aee2ff] bg-clip-text">
                Charlie Baby Unicorn AI
              </div>
              <img
                className="w-[30px] h-[50px] object-contain rotate-180"
                src="https://c.animaapp.com/mcbsvxniGDsCKx/img/vector-4.svg"
                alt="vector-end"
              />
            </div>
          </div>

          {/* Token Percentages */}
          <div className="w-full max-w-[773px] relative token-right-box">
            <div className="flex flex-row bg-[#3a3350] rounded-2xl w-full">
              {/* Left Column */}
              <div className="flex flex-col items-center justify-center gap-12 p-8 flex-1">
                {[
                  { value: "1B", label: "Total Supply" },
                  { value: "30%", label: "Presale Allocation" },
                  { value: "20%", label: "Staking Rewards" },
                ].map((item, i) => (
                  <div key={i} className="flex flex-col items-center gap-2">
                    <div className="text-4xl sm:text-5xl font-bold text-transparent bg-gradient-to-r from-[#ffa8d1] via-[#c3b1ff] to-[#aee2ff] bg-clip-text">
                      {item.value}
                    </div>
                    <div className="text-[18px] sm:text-[22px] text-neutral-100 text-center">
                      {item.label}
                    </div>
                  </div>
                ))}
              </div>

              {/* Divider */}
              <div className="w-px min-h-[100px] lg:min-h-[300px] bg-[linear-gradient(356deg,rgba(45,40,66,0)_2%,rgba(255,110,179,1)_16%,rgba(170,129,255,1)_47%,rgba(107,201,255,1)_83%,rgba(50,43,70,0)_97%)]" />

              {/* Right Column */}
              <div className="flex flex-col items-center justify-center gap-12 p-8 flex-1">
                {[
                  { value: "10%", label: "Team & Advisors" },
                  { value: "20%", label: "Community & Events" },
                  { value: "20%", label: "Liquidity & Reserve" },
                ].map((item, i) => (
                  <div key={i} className="flex flex-col items-center gap-2">
                    <div className="text-4xl sm:text-5xl font-bold text-transparent bg-gradient-to-r from-[#ffa8d1] via-[#c3b1ff] to-[#aee2ff] bg-clip-text">
                      {item.value}
                    </div>
                    <div className="text-[18px] sm:text-[22px] text-neutral-100 text-center">
                      {item.label}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Desktop Vertical Token Label */}
            <div className="hidden xl:flex flex-col items-center absolute left-[-150px] top-1/2 -translate-y-1/2 gap-2">
              <img
                className="w-[41.5px] h-[75.5px]"
                src="https://c.animaapp.com/mcbsvxniGDsCKx/img/vector-5.svg"
                alt="vector-start"
              />
              <div className="flex items-center gap-1 rotate-[-90deg]">
                <span className="text-[24px] font-bold text-transparent bg-gradient-to-r from-[#ffa8d1] via-[#c3b1ff] to-[#aee2ff] bg-clip-text">
                  Charlie Baby Unicorn AI
                </span>
              </div>
              <img
                className="w-[41.5px] h-[100.5px]"
                src="https://c.animaapp.com/mcbsvxniGDsCKx/img/vector-4.svg"
                alt="vector-end"
              />
            </div>
          </div>
        </div>

        {/* Glow */}
        <div className="absolute w-[579px] h-[579px] top-[109px] right-0 bg-[#ff81bc] rounded-full blur-[400px] z-0" />
      </div>
    </div>
  );
};
